import { useReanimatedKeyboardAnimation } from 'react-native-keyboard-controller';
import Reanimated, { useAnimatedStyle } from 'react-native-reanimated';

/**
 * Reserves the keyboard's height at the bottom of the screen, so everything
 * above it, a composer included, rides on top of the keyboard. Render it last
 * in a screen that runs to the bottom edge, and not on web.
 *
 * Deliberately not a keyboard-avoiding view. React Native's reads the
 * keyboard through its core events, which are unreliable under Android
 * edge-to-edge: the composer lifted, then stayed parked above where the
 * keyboard had been once it closed. The keyboard controller reads the IME
 * inset itself and follows the keyboard frame by frame on both platforms. And
 * because the screen runs to the bottom edge, the keyboard's height is exactly
 * the space to reserve, with no header offset to account for, whether the
 * header is native, transparent, or drawn in the screen's own tree.
 */
export function KeyboardSpacer() {
  const { height } = useReanimatedKeyboardAnimation();

  const style = useAnimatedStyle(() => ({ height: Math.max(0, -height.value) }));

  return <Reanimated.View style={style} />;
}
